export const extensionRoutes = [  {
    path: 'extensions/grupo-loja',
    loadChildren: () => import('./extensions/2c18682008f4c0ceeaa33458c0ff73be901d1e7e08d04d39ae9a8422aa58826a/routes'),
  }];
